import axios from "axios";
import {
  getFirstDateOfCurrentMonth,
  // getFirstDayOfPastThreeMonth,
  getLastDateOfCurrentMonth,
} from "@components/Common/Function";
import { getNodeServerUrl } from "@utils/getNodeUrl";

export const getOutletsBilledFtmApi = async (SH_Code__c, Title) => {
  const monthsLastDate = getLastDateOfCurrentMonth();
  const monthsFirstDate = getFirstDateOfCurrentMonth();
  const currentMonthLastDate = monthsLastDate;
  const currentMonthFirstDate = monthsFirstDate;

  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };

const nodeBaseUrl = getNodeServerUrl();

  const options = {
    url: `${nodeBaseUrl}/salesOperation/get-outlet-billed-ftm`,
    method: "post",
    headers: headers,
    data: { currentMonthLastDate, currentMonthFirstDate, SH_Code__c, Title },
  };

  try {
    const res = await axios(options);
    return res;
  } catch (error) {
    const errors = error?.response?.data?.error?.msg;
    if (errors) {
      return { error: error?.response?.data?.error?.msg };
    } else {
      return { error: "Something Went Wrong" };
    }
  }
};
